/* 拡大表示を横スワイプ対応にするための最小の補正（2026-08-06）
   必要な理由は2つ。どちらもCSSだけでは直せない。
   ① product-modal.js が `container.scrollLeft = (activeMedia.width - container.clientWidth)/2`
      を実行する。横並びにすると計算結果が0になり、何枚目を押しても1枚目が開いてしまう。
   ② モーダル内の img は loading="lazy" だが、初期状態が display:none のため
      ブラウザの遅延読み込みが発火せず、スワイプしても真っ白のままになる。
      → 表示中の前後2枚だけ eager にする（30枚を一度に読むと重い）。 */
(function () {
  var MQ = '(max-width: 749px)';
  function setup(modal) {
    var content = modal.querySelector('.product-media-modal__content');
    if (!content) return;
    var touched = false;

    function preload(center) {
      var kids = content.children;
      for (var i = center - 2; i <= center + 2; i++) {
        var k = kids[i];
        if (k && k.tagName === 'IMG' && k.loading === 'lazy') k.loading = 'eager';
      }
    }
    function snapToActive() {
      if (!window.matchMedia(MQ).matches) return;
      var kids = Array.prototype.slice.call(content.children);
      var i = kids.indexOf(content.querySelector('.active'));
      if (i < 0) return;
      content.scrollLeft = i * content.clientWidth;
      preload(i);
    }
    new MutationObserver(function (ms) {
      for (var j = 0; j < ms.length; j++) {
        if (ms[j].attributeName === 'open' && modal.hasAttribute('open')) {
          touched = false;
          setTimeout(snapToActive, 50);
          /* 読込で寸法が変わった時の保険。ただし人が既に触っていたら動かさない */
          setTimeout(function () { if (!touched) snapToActive(); }, 250);
        }
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    ['touchstart', 'wheel', 'pointerdown'].forEach(function (e) {
      content.addEventListener(e, function () { touched = true; }, { passive: true });
    });
    var t;
    content.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (window.matchMedia(MQ).matches) {
          preload(Math.round(content.scrollLeft / Math.max(1, content.clientWidth)));
        }
      }, 80);
    }, { passive: true });
  }
  function init() {
    var list = document.querySelectorAll('product-modal');
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
